export default class AutoComplete {
  public static AUTO_COMPLETE_DEBOUNCE_TIME = 330;
}
